// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_3uOCf","visuallyhidden":"_1gYHC","hide-text":"_31q7c","item":"_3BBFP","center":"_2UnV4","noprint":"_325gf","root":"_3e0QJ","highlight":"_1e0sy","active":"_3C6rE"};


/*****************
 ** WEBPACK FOOTER
 ** ./themes/ui-grade/styles/default.scss
 ** module id = 1003
 ** module chunks = 2
 **/